module.exports = __webpack_public_path__ + "img/eye-blue.dbacc8b6.svg";